/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { IPartner } from "shared/interface/types";

const initialState: { Partner: IPartner; PartnerUser: { pendingCounts: number }; EncashmentRequests: { pendingCounts: 0 } } = {
  Partner: {
    id: "",
    partnerName: "",
    contactNumber: "",
    email: "",
    address: "",
    city: {
      id: 0,
      name: ""
    },
    logoKey: "",
    isActive: true,
    updatedBy: "",
    updatedById: ""
  },
  PartnerUser: {
    pendingCounts: 0
  },
  EncashmentRequests: {
    pendingCounts: 0
  }
};

const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    AddPartner: (state, action) => {
      state.Partner = action.payload;
    },
    DeletePartner: state => {
      state.Partner = initialState.Partner;
    },
    UpdatePartnerUserPendings: (state, action) => {
      state.PartnerUser.pendingCounts = action.payload;
    },
    UpdateEncashmentRequestsPendings: (state, action) => {
      state.EncashmentRequests.pendingCounts = action.payload;
    }
  }
});

export const { AddPartner, DeletePartner, UpdatePartnerUserPendings, UpdateEncashmentRequestsPendings } = partnerSlice.actions;
export default partnerSlice.reducer;

export const getPartner = (state: RootState) => state.partner;
export const getPartnerUser = (state: RootState) => state.partner.PartnerUser;
export const getPartneEncashmentRequest = (state: RootState) => state.partner.EncashmentRequests;
